// Hero network panel geometry. Coordinates are in the 240x330 SVG viewBox.

export const NODES = [
  { x: 132, y: 44, n: "Glasgow" }, { x: 158, y: 96, n: "Newcastle" },
  { x: 132, y: 150, n: "Leeds" }, { x: 104, y: 176, n: "Manchester" },
  { x: 40, y: 158, n: "Belfast", ie: true }, { x: 34, y: 214, n: "Dublin", ie: true },
  { x: 130, y: 226, n: "Birmingham", hub: true }, { x: 70, y: 262, n: "Cardiff" },
  { x: 168, y: 286, n: "London", hub: true }, { x: 96, y: 296, n: "Bristol" },
];

export const ROUTES = [
  "M132 44 C150 64 152 76 158 96", "M158 96 C150 118 140 130 132 150",
  "M132 150 C122 160 114 168 104 176", "M104 176 C112 196 122 210 130 226",
  "M130 226 C142 248 156 268 168 286", "M40 158 C74 168 92 172 104 176",
  "M34 214 C60 218 96 222 130 226", "M70 262 C92 254 112 242 130 226",
  "M96 296 C118 292 148 290 168 286", "M104 176 C150 190 164 244 168 286",
];
